var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseFullScreenVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.559 14.6114H3.35107C2.90703 14.6114 2.54741 14.9694 2.54741 15.4118C2.54741 15.8534 2.90703 16.2122 3.35107 16.2122H8.67644L0 24.852L1.13648 25.9838L9.80396 17.3519L9.7788 22.6123C9.7788 23.054 10.1384 23.4127 10.5825 23.4127C11.0265 23.4127 11.3861 23.0548 11.3861 22.6123V15.4109C11.3861 15.1739 11.2879 14.9823 11.132 14.8507C10.9851 14.7047 10.783 14.6114 10.559 14.6114ZM22.6498 9.78772H17.3244L26 1.14786L24.8635 0.0162258L16.1968 8.64797L16.222 3.38756C16.222 2.94594 15.8624 2.58712 15.4183 2.58712C14.9743 2.58712 14.6147 2.94513 14.6147 3.38756V10.589C14.6147 10.826 14.7129 11.0176 14.8679 11.1483C15.014 11.2961 15.2154 11.3894 15.4403 11.3894H22.6481C23.0922 11.3894 23.4518 11.0314 23.4518 10.589C23.4526 10.1465 23.093 9.78772 22.6498 9.78772Z",
    fill: "#4B9BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFullScreenVideo);
export default __webpack_public_path__ + "static/media/close_full_screen_video.3b1436e0c75335cf9668a1f3cbb2e2f6.svg";
export { ForwardRef as ReactComponent };